["foxsports.com.au",
"news.com.au",
"nine.com.au",
"7news.com.au",
"theguardian.com",
"theage.com.au",
"9news.com.au",
"smh.com.au"]
